module.exports = __webpack_public_path__ + "img/courseicon.07b66d19.svg";